module.exports = require("live/init/global-locale");